<avd-styling-card-shell [label]="label" [inverseMode]="inverseMode">
    <div token-card-preview class="preview">
        <div class="preview__icons">
            <uilab-mat-icon
                class="preview__icon"
                [style.color]="iconColor"
                svgIcon="navigation--home_filled"
            ></uilab-mat-icon>
            <uilab-mat-icon
                class="preview__icon"
                [style.color]="iconColor"
                svgIcon="navigation--home_outlined"
            ></uilab-mat-icon>
            <uilab-mat-icon
                class="preview__icon"
                [style.color]="iconColor"
                svgIcon="navigation--home_grayscale"
            ></uilab-mat-icon>
        </div>
    </div>

    <avd-css-variable-snippet
        token-card-snippets
        [snippet]="cssVariableSnippet"
        language="css"
    ></avd-css-variable-snippet>
</avd-styling-card-shell>
